module.exports = __webpack_public_path__ + "static/media/galeryCurtains1.61bcef05.jpg";